<template>
	<div class="container pt-6 pb-10">
		<div class="flex flex-col lg:flex-row justify-between items-center mb-6">
			<h1 v-if="isNull" class="page-title">Adauga materiale</h1>
			<h1 v-else class="page-title">Editeaza materiale</h1>
		</div>

		<EditMateriale v-if="currentOferta" :alte_obj="isNull ? materiale : currentOferta.alte_obj"
			:country="currentOferta.country" :tip_lucrare="currentOferta.tip_lucrare" :tip="'oferta'"
			:id="currentOferta.id_oferta"></EditMateriale>
	</div>
</template>

<script>
import EditMateriale from "@/components/Productie/EditMateriale";

export default {
	name: "OfertaMateriale",
	data() {
		return {
			materiale: [
				{
					nr: "1",
					denumire: "",
					// the catalogue product this line came from; empty on a line typed by hand
					cod: "",
					cantitate: "",
					um: "",
					pret: "",
					pret_v: "",
					marja: "",
					pret_t: "",
				},
			],
		};
	},
	components: {
		EditMateriale,
	},
	computed: {
		currentOferta() {
			return this.$store.getters.currentOfertaProductie;
		},
		isNull() {
			if (this.currentOferta.alte_obj) {
				return false;
			} else {
				return true;
			}
		},
	},
	methods: {},
	created: function () {
		this.$store.dispatch("fetchOfertaProductie", this.$route.params.id);
	},
	mounted: function () { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
